import { mutationTypes } from '@/core/constants'
import EstornarItemPedidoInput from '@/core/apiclient/item-pedido/estorno/models/EstornarItemPedidoInput'

export default {
	[mutationTypes.ITEM_PEDIDO.ESTORNO.ESTORNAR.SET_FORM](state, { itensPedido, quantidadeEstorno, justificativa }) {
		state.form = new EstornarItemPedidoInput(itensPedido, justificativa, quantidadeEstorno)
	},
	[mutationTypes.ITEM_PEDIDO.ESTORNO.ESTORNAR.RESET_FORM](state) {
		state.form = new EstornarItemPedidoInput([], null, null)
	},
}
